import { Component } from '@angular/core';

@Component({
    selector: 'app-splash',
    imports: [],
    templateUrl: './splash.component.html',
    styleUrl: './splash.component.scss'
})
export class SplashComponent {

   
}
